module.exports = __webpack_public_path__ + "img/50coin@2x.d9e80009.png";